<div class="grid">
  <!-- Success state -->
  <ng-container *ngIf="!error">
    <h2>{{ "pages.confirmEmailChange.title" | translate }}</h2>
    <h5>{{ "pages.confirmEmailChange.description" | translate }}</h5>
    <button
      [nbSpinner]="loading"
      nbSpinnerStatus="primary"
      type="submit"
      nbButton
      status="primary"
      (click)="onLogin()"
      [disabled]="loading"
    >
      {{ "buttons.toLogin" | translate }}
    </button>
  </ng-container>

  <!-- Invalid / expired / conflict state -->
  <ng-container *ngIf="error">
    <h2>
      {{
        (conflict
          ? "pages.confirmEmailChange.conflictTitle"
          : "pages.confirmEmailChange.errorTitle"
        ) | translate
      }}
    </h2>
    <h5>
      {{
        (conflict
          ? "pages.confirmEmailChange.conflictDescription"
          : "pages.confirmEmailChange.errorDescription"
        ) | translate
      }}
    </h5>

    <a class="login-link" routerLink="/auth/login">{{ "buttons.toLogin" | translate }}</a>
  </ng-container>
</div>
